import React from "react";
import Sidebar from "../components/trackweb/Sidebar/Sidebar";

import { Navigate } from "react-router-dom";
import useTrackWebContext from "../hooks/useTrackWebContext";
import ShopMetrics from "../components/trackweb/ShopMetrics/ShopMetrics";

const Metrics = () => {
  const { isLogin } = useTrackWebContext();

  return (
    <>
      <main className="track-web min-h-screen relative bg-[#f9f9f9]">
        {!isLogin && <Navigate to="/login" replace={true} />}
        <div
          className="
          flex flex-col m-auto my-0 items-start font-body
          md:w-full md:p-4
          lg:flex-row min-h-[101vh] lg:p-6
          xl:max-w-[1388px] xl:pt-[52px] xl:px-[50px] xl:pb-[50px]
          "
        >
          <Sidebar />
          <ShopMetrics />
        </div>
      </main>
    </>
  );
};

export default Metrics;
